import React, { cloneElement, useState } from "react";

import { string, node, arrayOf, shape, number } from "prop-types";
import Separator from "./separator";
import { cn } from "./utils";
import { Check } from "lucide-react";

const StepFlow = ({ steps, initialStepIndex }) => {
  const [currentStepIndex, setCurrentStepIndex] = useState(initialStepIndex);
  const currentStep = steps[currentStepIndex];

  return (
    <div className="flex h-full flex-col gap-24 overflow-auto">
      <div className="flex">
        {steps.map((step, index) => (
          <div key={step.name} className="flex flex-1 flex-col">
            <Separator
              hideLeft={index === 0}
              hideRight={index === steps.length - 1}
            >
              <div
                className={cn(
                  "flex h-12 w-12 items-center justify-center rounded-full bg-gray-100 text-md font-bold text-gray-400",
                  { "bg-primary text-white": index === currentStepIndex },
                )}
              >
                {currentStepIndex > index ? (
                  <Check size={14} strokeWidth={4} />
                ) : (
                  index + 1
                )}
              </div>
            </Separator>
            <div
              className={cn("flex max-w-[200px] self-center px-4 text-center", {
                "font-bold": index === currentStepIndex,
              })}
            >
              {step.title}
            </div>
          </div>
        ))}
      </div>
      <div>
        {cloneElement(currentStep.component, {
          jumpToStep: setCurrentStepIndex,
        })}
      </div>
    </div>
  );
};

StepFlow.propTypes = {
  initialStepIndex: number,
  steps: arrayOf(
    shape({
      name: string.isRequired,
      title: string.isRequired,
      component: node.isRequired,
    }),
  ),
};

StepFlow.defaultProps = {
  initialStepIndex: 0,
};

export default StepFlow;
